export default __webpack_public_path__ + "images/WN.dd40d70.png";